export default __webpack_public_path__ + "static/media/ui.25bb8355.png";